const debounce = (fn, time) => {
    let timeout;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function debounced(...args) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        const functionCall = () => fn.bind(that)(...args);
        clearTimeout(timeout);
        // browser/node return different type from setTimeout - number or Timer
        // @ts-ignore
        timeout = setTimeout(functionCall, time);
    };
};

export { debounce };
